// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"e2047b3d","504":"16993eb5"}[chunkId] + ".chunk.js";
};